import { gql } from "@apollo/client";

export default gql`
  query GetCompletedCertificates {
    getCompletedCertificates {
      providerno
      email
      username
      racgp
      acrrm
      other_membership
      cp_id
      cpe_id
      programname
      racgp_activity_num
      acrrm_activity_num
      fullname
      surname
      given_name
      searchfullcount
      certificatedate
      year
      pdf_template
    }
  }
`;
